export enum GrayscaleHitKeyEnum {
  VSA_GRAYSCALE = 'vsa_graysacle',
  CONNECTION_QUOTA_GRAYSCALE = 'gmv_quota_grayscale',
  FLAT_FEE_GRAYSCALE = 'flat_fee_grayscale',
}
